const getIncidentData = state => state.incidentData || {};
export const getIncident = state => getIncidentData(state).incident || {};
export const getIncidentError = state => getIncidentData(state).error || {};
